import React from 'react'
import Skeleton from 'react-loading-skeleton'

import useStyles from './styles'

const SkeletonInputField = () => {
  const classes = useStyles({
    hasValue: true,
    hasSymbol: false,
    symbolLength: 0,
    symbolPosition: ''
  })

  return (
    <div className="field" style={{ position: 'relative', backgroundColor: 'white' }}>
      <div className={classes.input}>
        <Skeleton width={170} />
      </div>
    </div>
  )
}

export default SkeletonInputField
